<template>
  <div>
    <div class="swiper-list">
      <div class="button-prev" @click="swiperChange('prev')">
        <svg
          t="1603440419638"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2695"
          width="32"
          height="32"
        >
          <path
            d="M671.807 927.804l-415.632-415.804 415.632-415.803 63.445 63.616-352.017 352.209 352.017 352.102z"
            p-id="2696"
            fill="#8a8a8a"
          ></path>
        </svg>
      </div>
      <!-- Swiper -->
      <div class="swiper-container" v-swiper:mySwiper="swiperOption" v-if="swiperList.length>0">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in swiperList" :key="index">
            <div class="logo" v-for="inner in item" :key="inner.id" @click="toDetail(inner)">
                <img :src="inner.headUrl" alt="">
            </div>
             <!-- <div @click="toDetail(inner)" class="logo" :style="{backgroundImage:`url(${inner.headUrl})`}" v-for="inner in item" :key="inner.id"></div> -->
          </div>
        </div>
      </div>
      <div class="button-next" @click="swiperChange('next')">
        <svg
          t="1603440337801"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2017"
          width="32"
          height="32"
        >
          <path
            d="M325.048 93.511l-60.030 59.435 357.181 359.631-360.184 356.603 59.522 59.93 420.207-416.043z"
            p-id="2018"
            fill="#8a8a8a"
          ></path>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import {routerGoNewpage} from "@/utils/index"
export default {
  props:{
     list:{
       type:Array
     }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 6,
        slidesPerColumn: 1,
      },
      swiperList:[],
      currPage:1
    };
  },
  created(){
    this.swiperList = this.caculateList();
  },
  methods: {
    //跳转到详情
    toDetail(item){
       routerGoNewpage('/corporate_detail',{id:item.userId});
    },
    caculateList(){
       let list = [];
       this.list.map((item,index)=>{
           let iIndex = Math.floor(index/2);
           !list[iIndex] && (list[iIndex] = []);
           list[iIndex].push(item);
       });
       return list;
     },
    //切换轮播图
    swiperChange(type) {
      switch (type) {
        case "prev":
          this.mySwiper.slidePrev();
          break;

        default:
          this.mySwiper.slideNext();
          if(this.mySwiper.slideNext() == false){
             this.currPage ++;
             this.$emit('onParant',this.currPage)
          }
          break;
      }
    },
  },
};
</script>

<style scoped>
.swiper-container {
  width: 100%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  height: calc((100% - 30px) / 2);

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  align-items: center;
  flex-direction: column;
}
.swiper-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.logo {
  width: 100%;
  height: 97px;
  background-position: center;
  background-size: cover;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #EBEBEB;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo a{
   width: 169px;
   height: 95px;
}
.logo img{
  height: 69px;
  width: 69px;
  border-radius: 100%;
}
.button-prev,
.button-next {
  cursor: pointer;
  z-index: 999;
}
</style>


// WEBPACK FOOTER //
// src/components/swiperList.vue